import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";
import { enqueueSnackbar } from "notistack";

export function useAddSettingKey() {
  const [addMutation, { loading }] = useMutation<any>(mutations.addSettingKey, {
    errorPolicy: "all",
  });

  const addSettingKey = useCallback(
    async (variables: { key: string; type: string }) => {
      try {
        const res = await addMutation({
          variables,
          refetchQueries: ["SettingKeys"],
        });
        const result = res.data?.addSettingKey;
        if (result?.success) {
          enqueueSnackbar(result.message?.[0] || "Key added successfully!", {
            variant: "success",
          });
          return true;
        } else {
          enqueueSnackbar(result?.message?.[0] || "Failed to add key", {
            variant: "error",
          });
          return false;
        }
      } catch (err: any) {
        enqueueSnackbar(err.message || "An error occurred", {
          variant: "error",
        });
        return false;
      }
    },
    [addMutation],
  );

  return {
    addSettingKey,
    loading,
  };
}
